import {Component, Input, OnInit, OnDestroy} from '@angular/core';
import {Subscription} from 'rxjs/Subscription';
import {FooterNavbarService} from 'services/connectors/footer-navbar.service';
import {NavbarService} from 'services/connectors/navbar.service';
import {Router, NavigationEnd, Event} from '@angular/router';

@Component({
    selector: 'tpc-navbar',
    templateUrl: './navbar.component.html',
    styleUrls: ['./navbar.component.css']
})
export class NavbarComponent implements OnInit, OnDestroy {
    @Input() calculatorName;
    @Input() menuItems;

    private categoryName: string;
    public methodology = {};
    public isThankYouScreen = false;
    private thankYouScreenCategoryName = 'complete';
    private skipSub: Subscription;
    private routerEventsSub: Subscription;

    constructor(private footerService: FooterNavbarService,
                private navbarService: NavbarService,
                private router: Router
    ) {
        this.skipSub = footerService.skip$.subscribe(() => {
            this.moveToNextCategory(router.url);
        });

        this.routerEventsSub = router.events.subscribe((event: Event) => {
            let categoryName = this.getCurrentCategoryName(this.router.url);

            if (event instanceof NavigationEnd) {
                if (categoryName === this.thankYouScreenCategoryName) {
                    this.isThankYouScreen = true;
                } else {
                    this.isThankYouScreen = false;
                    this.categoryName = categoryName;
                }

                this.navbarService.changeCategory({
                    categoryName: this.categoryName,
                    calculatorName: this.calculatorName,
                    isThankYouScreen: this.isThankYouScreen
                });
            }
        });
    }

    ngOnInit() {
        this.categoryName = this.getCurrentCategoryName(this.router.url);
        this.navbarService.changeCategory({
            categoryName: this.categoryName,
            calculatorName: this.calculatorName,
            isThankYouScreen: this.isThankYouScreen
        });
    }

    private getMenuItemIndex(currentUrl): number {
        let urlArray = currentUrl.split('/');
        urlArray.pop();
        let cuttedUrl = urlArray.join('/');
        return this.menuItems.findIndex(item => item.url === cuttedUrl);
    }

    private getCurrentCategoryName(currentUrl): string {
        let urlArray = currentUrl.split('/');
        return urlArray.splice(2, 1)[0]; // url contains "", calculatorName, categoryName = so we take 2 in array
    }

    private moveToNextCategory(currentUrl): void {
        let currentCategoryIndex = this.getMenuItemIndex(currentUrl);
        if (currentCategoryIndex !== -1) {
            this.menuItems[currentCategoryIndex].checked = true;
            let nextCategory = this.menuItems[currentCategoryIndex + 1];
            let nextCategoryUrl = this.getThankYouUrl();

            if (nextCategory !== undefined) {
                nextCategoryUrl = nextCategory.url;
            }
            this.goToCategory(nextCategoryUrl);
        }
    }

    private getThankYouUrl(): string {
        return `/${this.calculatorName}/complete/thankyou`;
    }

    openItem(item, isOpen = true): void {
        item.width = isOpen ? 240 : 36;
        item.checkedOffset = isOpen ? 6 : -8;
    }

    goToCategory(url): void {
        this.router.navigate([url]);
    }

    openMethodology(e) {
        e.preventDefault();
        this.navbarService.openMethodology({categoryName: this.categoryName, calculatorName: this.calculatorName});
    }

    getLinkClassName(name): string {
        return `btn btn-default btn-circle-36 category-nav-btn ico-${name} ${this.calculatorName}-${name}-bg`;
    }

    ngOnDestroy() {
        if (this.skipSub) {
            this.skipSub.unsubscribe();
        }

        if (this.routerEventsSub) {
            this.routerEventsSub.unsubscribe();
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/components/calculator/calculator-item/shared/navbar/navbar.component.ts